import { Container } from 'ui';
import { Stack } from '@koob/margaret';
import { EditorField } from '../../../../components/Fields';
import React from 'react';
import { useField } from 'formik';
import { EXPERIENCE_CONDITION_SCHEMA } from '../Utilities/ExperienceValidationSchemas';
import { ExperienceCancelConditions } from './ExperienceConditions';
import { OrgFallbackConditions } from './ExperienceConditions/OrgFallbackConditions';
import { useTranslation } from 'react-i18next';

export function ExperienceCondition({ isReadOnly = false }) {
  const [{ value: experienceType }, ,] = useField('type');
  const { t } = useTranslation('experiences', {
    keyPrefix: 'form.cancelConditions',
  });
  const [{ value: currency }] = useField('currency');

  return (
    <Container size="full">
      {experienceType !== 'Extra' && (
        <div className="my-2">
          <Stack direction="column" gutterSize={2.5}>
            <div className="w-full">
              <div className="flex items-center gap-2 mb-1">
                <i className="fa-regular fa-file-lines text-2xl text-orange-500" />
                <h2 className="text-lg font-semibold text-gray-800">
                  {t('plainTextPolicies.title')}
                </h2>
              </div>
              <p className="text-sm text-gray-500 mb-4">
                {t('plainTextPolicies.description')}
              </p>
              <EditorField
                name="cancellationPolicies"
                fillSpace
                disabled={isReadOnly}
              />
            </div>

            <div className="w-full">
              <div className="flex items-center gap-2 mb-1">
                <i className="fa-regular fa-calendar text-2xl text-orange-500" />
                <h2 className="text-lg font-semibold text-gray-800">
                  {t('dynamicConditions.title')}
                </h2>
              </div>
              <p className="text-sm text-gray-500 mb-4">
                {t('dynamicConditions.description')}
              </p>

              <ExperienceCancelConditions
                name="cancelConditions"
                currency={currency}
                disabled={isReadOnly}
              />
              <OrgFallbackConditions currency={currency} />
            </div>
          </Stack>
        </div>
      )}
    </Container>
  );
}

export const getSchema = () => {
  return EXPERIENCE_CONDITION_SCHEMA;
};
